//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import { ModelSelect, ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import UMUM from "../../library/umum.js";
import DATA_MASTER from "../../library/dataMaster";

export default {
  components: {
    ModelSelect,
    ModelListSelect
  },
  data() {
    return {
      list_data: {},

      instansi_id: "",
      unit_kerja: "",
      unit_kerja_full: "",
      unit_kerja_edit: "",

      filterku : {
        instansi : '',
        unit_kerja : '',
        fileStat : false,
      },

      printObj: {
              id: "printMe",
              popTitle: 'good print',
              extraCss: 'https://www.google.com,https://www.google.com',
              extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
            },

      UMUM: UMUM,
      DATA_MASTER: DATA_MASTER,
      output: null,

      // heightEssIII : 0,

    }
  },
  methods: {
    getView : function(){
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_simpeg_jabatan + "cetakData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              unit_kerja: this.filterku.unit_kerja,
              instansi: this.filterku.instansi,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              // console.log(res_data.jabatan);
              this.list_data = res_data;

              this.unit_kerja_full = res_data.unit_kerja
  
                setTimeout(()=>{
                  this.getHeight("GetEssIII");
                  this.getHeight("GetEssIII1");
                  this.getHeight("GetEssIV");
                  this.getHeight("GetEssIV1");
                },500);
      });
    },


    getHeight(datax){
      // GetEssIII
      var dataClass = document.getElementsByClassName(datax);
      var max_height = 0;
      for (var i = 0; i < dataClass.length; i++) {
        var dataClass_width =dataClass[i].offsetHeight;
        // console.log(dataClass_width)
        max_height = Math.max(max_height, dataClass_width);
      }
      // console.log(max_height)
      for (var i = 0; i < dataClass.length; i++) {
        dataClass[i].style.height = max_height+"px";
      }
      // this.heightEssIII = max_height
      // console.log('aaaaaaaaaaaaaa')
      // console.log(dataClass.length)
    },
    getEsselonColor(esselon){
      if (esselon == '1') {
        return 'bg-amber'
      }
      else if (esselon == '2'){
        return 'bg-amber-14'
      }
      else if (esselon == '3'){
        return 'bg-light-blue-9'
      }
      else if (esselon == '4'){
        return 'bg-green-5'
      }
      else if (esselon == '5'){
        return 'bg-red-4'
      }
      else if (esselon == '6'){
        return 'bg-grey-7'
      }
      else {
        return 'blue-grey-7'
      }
    },





  },




  mounted () {
    var get_profile = JSON.parse(localStorage.profile);
    this.filterku.unit_kerja = get_profile.profile.unit_kerja;
    this.filterku.instansi = get_profile.profile.instansi_id;
    this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
    this.unit_kerja = get_profile.profile.unit_kerja;

    DATA_MASTER.getInstansi();
    DATA_MASTER.getUnitKerja(this.filterku.instansi);

    this.getView();


    this.printDiv()




  },







};
